// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Yn5X","hidden":"_3mB8Q","pointer":"_2xW7r"};